import React from 'react';
import { IconBuilding } from '@tabler/icons-react';
import { BoardClickUpFilterChipDropdown } from './BoardClickUpFilterChipDropdown';

/** Chip "Cliente" estilo ClickUp — mesmo padrão Coordenador/Área/Técnicos. */
export function BoardToolbarClienteClickUpChip(props) {
  return (
    <BoardClickUpFilterChipDropdown
      {...props}
      label="Cliente"
      icon={IconBuilding}
      pickerMode="simple"
      pickerWidth={280}
      pickerMaxHeight={320}
      searchPlaceholder="Buscar"
      countLabel="clientes"
      listAriaLabel="Clientes"
      popoverClassName="board-search-filters-popover--cliente"
      emptyMessage="Nenhum cliente encontrado"
    />
  );
}
